import { AwardType } from '@occc-app/offerHelpers/types';

import { AwardButton } from './earning-mechanism-award-selector.types';

export const getButtonsByTypes = (types: AwardType[]): AwardButton[] => {
  const hasNothing = types.includes(AwardType.AwardNullable);
  const hasExternal = types.includes(AwardType.AwardExternal);
  const hasPoints = types.includes(AwardType.AwardPoints);
  const hasVouchers = types.includes(AwardType.AwardVouchers);

  const result: AwardButton[] = [];

  // The order of buttons matters Nothing, Points, Award (is required order on UI)
  if (hasNothing) {
    result.push({ title: 'Nothing', value: AwardType.AwardNullable });
  }
  // There should not be the case when both Nothing and External are present
  if (hasExternal) {
    result.push({ title: 'Nothing', value: AwardType.AwardExternal });
  }

  if (hasPoints) {
    result.push({ title: 'Points', value: AwardType.AwardPoints });
  }

  if (hasVouchers) {
    result.push({ title: 'Award', value: AwardType.AwardVouchers });
  }

  return result;
};
